export const orderedList = {
	group: "block list",
	content: "listItem+",
	attrs: {
		order: { default: 1 },
		tight: { default: false },
	},
};
